import React, { FC } from 'react';
import Box from "@mui/material/Box";
import {ChevronLeft, Close} from "@mui/icons-material";
import {IconButton} from "@mui/material";
import Typography from "@mui/material/Typography";

type AppDialogTitleProps = { title: string, onClose?: () => void, onBack?: () => void };


const AppDialogTitle: FC<AppDialogTitleProps> = ({ title, onClose, onBack }) => {
	return (
		<Box
			sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', pl: onBack ? 0 : 1.5,pr: 0, py: 1, width: 1, mb: 2 }}
		>
			<Box sx={{ display: 'flex', alignItems: 'center' }}>
				{onBack && (
					<IconButton onClick={onBack} sx={{ mr: 1 }}>
						<ChevronLeft />
					</IconButton>
				)}
				<Typography variant="appHugeBold">{title}</Typography>
			</Box>
			{onClose && (
				<IconButton onClick={onClose}>
					<Close />
				</IconButton>
			)}
		</Box>
	);
}

export default AppDialogTitle;

